import { gql } from "@urql/svelte";

export const GalleryApi = gql`
    query GalleryQuery($galleryId: Int) {
        gallery(galleryId: $galleryId) {
            id
            title
            description
            itemCount
            items {
                id
                text
                imageSrc
                copyright
                thumbnailSrc
                type
            }
        }
    }
`;
